import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { getControl, getFormArray } from '@shared/helpers/form.helper';
import { withInitialValueDebounced } from '@shared/operators/with-initial-value-debounced.operator';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { cloneDeep } from 'lodash-es';
import { debounceTime, merge, startWith } from 'rxjs';
import { Utilities } from '@core/helpers/utilities';
import { toNum } from '@shared/helpers/math.helper';
import { getContribBiennaleControl } from '../validators/helpers/contrib-biennale-form.helpers';

export const setContribBiennaleMoraSanzioniListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_mora(form, store);
    my_sanzione(form, store);
    my_totaleMoraSanzione(form, store);
    my_NumeroContoCorrente(form, store);
};

const my_mora = (form: FormGroup, store: Store<Revisione53State>): void => {
    const my_moraHiddenCtrl = getControl(form, 'my_moraHidden');
    const my_moraCtrl = getControl(form, 'my_mora');
    my_moraHiddenCtrl.valueChanges.pipe(withInitialValueDebounced(my_moraHiddenCtrl)).subscribe((value: string) => {
        my_moraCtrl.patchValue(value, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_mora = value;
            return myVerbaleClone;
        });
    });
};

const my_sanzione = (form: FormGroup, store: Store<Revisione53State>): void => {
    const my_sanzioneHiddenCtrl = getControl(form, 'my_sanzioneHidden');
    const my_sanzioneCtrl = getControl(form, 'my_sanzione');
    my_sanzioneHiddenCtrl.valueChanges.pipe(withInitialValueDebounced(my_sanzioneHiddenCtrl)).subscribe((value: string) => {
        my_sanzioneCtrl.patchValue(value, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_sanzione = value;
            return myVerbaleClone;
        });
    });
};

const my_totaleMoraSanzione = (form: FormGroup, store: Store<Revisione53State>): void => {
    const my_moraHiddenCtrl = getControl(form, 'my_moraHidden');
    const my_sanzioneHiddenCtrl = getControl(form, 'my_sanzioneHidden');
    const my_totaleMoraSanzioneCtrl = getControl(form, 'my_totaleMoraSanzione');

    merge(my_moraHiddenCtrl.valueChanges.pipe(startWith(my_moraHiddenCtrl.value)), my_sanzioneHiddenCtrl.valueChanges.pipe(startWith(my_sanzioneHiddenCtrl.value)))
        .pipe(debounceTime(Utilities.LISTENERS_DEBOUNCE_TIME))
        .subscribe(() => {
            const result = (toNum(my_moraHiddenCtrl.value) + toNum(my_sanzioneHiddenCtrl.value)).toString(10);
            my_totaleMoraSanzioneCtrl.patchValue(result, { emitEvent: false });
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_totaleMoraSanzione = result;
                return myVerbaleClone;
            });
        });
};

const my_NumeroContoCorrente = (form: FormGroup, store: Store<Revisione53State>): void => {
    const contoCorrenteCtrl = getContribBiennaleControl(form, 'my_ContoCorrentePrevistoPerVersamento');
    contoCorrenteCtrl.valueChanges.pipe(withInitialValueDebounced(contoCorrenteCtrl)).subscribe((value: string) => {
        const righeArray = getFormArray(form, 'my_RTCalcoloMoraSanzione.my_RTRigaCalcoloMoraSanzione');
        righeArray.controls.forEach((rigaCtrl) => {
            getControl(rigaCtrl as FormGroup, 'my_NumeroContoCorrente')?.patchValue(value, { emitEvent: false });
        });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone.my_RTCalcoloMoraSanzione?.my_RTRigaCalcoloMoraSanzione?.forEach((riga) => {
                riga.my_NumeroContoCorrente = value;
            });
            return myVerbaleClone;
        });
    });
};
